<template>
  <v-card elevation="0" class="px-4">
    <v-divider></v-divider>

    <div class="d-flex justify-space-between mt-6">
      <div class="d-flex align-center">
        <h2 class="mb-2 mr-4"
          style="font-weight: 400; color: #203a75; font-size: 1.5rem; background-color: #f5f5f5; padding: 8px 20px; border-radius: 6px;">
          Unidades de Negócio</h2>
      </div>

     
    </div>

    <div class="d-flex justify-space-between mb-3">
      <div class="d-flex align-center">
        <v-text-field style="width: 445px" v-model="search" append-icon="mdi-magnify" outlined
          label="Buscar (Nome, Razão Social ou CNPJ)" single-line dense hide-details>
        </v-text-field>
      </div>
      <div class="d-flex justify-space-between" >
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              icon
              color="primary" 
              @click="handleBulkCNPJCheck"
              :loading="loadingBulkCNPJ"
              :disabled="loadingBulkCNPJ"
              class="mr-4"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </template>
          <span>Verificar situação de todos os perfis</span>
        </v-tooltip> -->
         <div class="d-flex align-center">
        <v-btn color="green" dark to="/app/management/profiles/create">Adicionar</v-btn>
      </div>
        <!-- <v-btn>
          <v-icon left>mdi-view-grid</v-icon>
          Editar matriz
        </v-btn> -->
      </div>
    </div>

    <v-card outlined>
      <v-data-table :headers="headers" :items="filteredProfiles" :items-per-page="10" :sort-by="sortBy"
        :sort-desc="sortDesc" :loading="loading" class="elevation-1">

        <template v-slot:[`item.logo`]="{ item }">
          <div class="text-center">
            <v-avatar size="40">
              <v-img :src="item.logo" :alt="item.displayName"></v-img>
            </v-avatar>
          </div>
        </template>

        <template v-slot:[`item.isDefault`]="{ item }">
          <div class="text-center">
            <v-icon v-if="item.isDefault === 1 && item.id === firstDefaultId" color="green" size="20">
              mdi-check-circle
            </v-icon>
            <v-icon v-else-if="item.isDefault === 1" color="red" size="20">
              mdi-close-circle
            </v-icon>
            <v-icon v-else color="red" size="20">
              mdi-close-circle
            </v-icon>
          </div>
        </template>

        <template v-slot:[`item.displayName`]="{ item }">
          <div class="text-center">{{ item.displayName }}</div>
        </template>

        <template v-slot:[`item.name`]="{ item }">
          <div class="text-center">{{ item.name }}</div>
        </template>

        <template v-slot:[`item.document`]="{ item }">
          <div class="text-center">{{ formatCNPJ(item.document) }}</div>
        </template>

        <template v-slot:[`item.createdOn`]="{ item }">
          <div class="text-center">{{ formatDate(item.createdOn) }}</div>
        </template>

        <template v-slot:[`item.cnpjStatus`]="{ item }">
          <div class="text-center d-flex align-center justify-center">
            <v-btn icon x-small color="primary" @click="checkCnpjStatus(item)" :loading="loadingStatuses[item.id]"
              :disabled="loadingStatuses[item.id]" class="mr-2">
              <v-icon small>mdi-reload</v-icon>
            </v-btn>

            <v-chip class="white--text" small :color="getCnpjStatusColor(item.id)">
              {{ cnpjStatuses[item.id] || '-' }}
            </v-chip>
          </div>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <div class="text-center">
            <v-tooltip bottom v-if="getProfilePendencies(item.profileId).length === 0">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="green" v-bind="attrs" v-on="on">mdi-check-circle</v-icon>
              </template>
              <span>Cadastro completo</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="red" v-bind="attrs" v-on="on">mdi-information</v-icon>
              </template>
              <span>Pendências: {{ getProfilePendencies(item.profileId).join(', ') }}</span>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="text-center">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="#0e1439"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item :to="`/app/management/profiles/${item.profileId}?tab=cadastral`">
                  <v-list-item-icon>
                    <v-icon color="#0e1439">mdi-pencil-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Dados cadastrais</v-list-item-title>
                </v-list-item>
                
                <v-list-item :to="`/app/management/profiles/${item.profileId}?tab=address`">
                  <v-list-item-icon>
                    <v-icon color="#0e1439">mdi-map-marker-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Endereços</v-list-item-title>
                </v-list-item>
                
                <v-list-item :to="`/app/management/profiles/${item.profileId}?tab=inventories`">
                  <v-list-item-icon>
                    <v-icon color="#0e1439">mdi-view-dashboard-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Inventários</v-list-item-title>
                </v-list-item>
                
                <v-list-item :to="`/app/management/profiles/${item.profileId}?tab=bank-data`">
                  <v-list-item-icon>
                    <v-icon color="#0e1439">mdi-bank</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Dados bancários</v-list-item-title>
                </v-list-item>
                
              </v-list>
            </v-menu>
          </div>
        </template>

      </v-data-table>
    </v-card>

    <ProfileEditModal v-if="selectedProfileId" v-model="showEditModal" :profileId="selectedProfileId" />
  </v-card>
</template>

<script>
import ProfileEditModal from './ProfileEditModal.vue';
import { mapGetters } from 'vuex';
import { getAuth } from '@/services/authService'

export default {
  name: 'ProfilesList',

  components: {
    ProfileEditModal
  },

  data() {
    return {
      get auth() {
        return getAuth()
      },

      profiles: {},

      headers: [
        {
          text: "Logo",
          value: "logo",
          align: "center",
          sortable: false,
          width: "80px"
        },

        {
          text: "Nome de exibição",
          value: "displayName",
          align: "center",
          sortable: false,
        },
        {
          text: "Razão Social",
          value: "name",
          align: "center",
          sortable: false,
        },
        {
          text: "CNPJ",
          value: "document",
          align: "center",
          sortable: false,
        },
         {
          text: "Criado em",
          value: "createdOn",
          align: "center",
          sortable: false,
        },
        {
          text: "Situação RFB",
          value: "cnpjStatus",
          align: "center",
          sortable: false,
          width: "160px"
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false,
          width: "100px"
        },
        {
          text: "Dados Cadastrais",
          value: "actions",
          align: "center",
          sortable: false,
          width: "150px"
        },
      ],
      loading: false,
      search: "",
      sortBy: "displayName",
      sortDesc: false,
      showEditModal: false,
      selectedProfileId: null,
      cnpjStatuses: {},
      loadingStatuses: {},
      loadingBulkCNPJ: false,
    }
  },

  computed: {
    profilesData() {
      if (!this.profiles || Object.keys(this.profiles).length === 0) return [];

      return Object.keys(this.profiles)
        .map(key => ({
          id: key,
          ...this.profiles[key]
        }))
        .filter(profile => profile.profileType === 2);
    },

    filteredProfiles() {
      let profiles = this.profilesData;

      if (this.search) {
        const searchTerm = this.search.toLowerCase();
        profiles = profiles.filter(profile => {
          const matchDisplayName = profile.displayName && profile.displayName.toLowerCase().includes(searchTerm);
          const matchName = profile.name && profile.name.toLowerCase().includes(searchTerm);
          const matchDocument = profile.document && profile.document.toLowerCase().includes(searchTerm);

          return matchDisplayName || matchName || matchDocument;
        });
      }

      return profiles.sort((a, b) => {
        if (a.isDefault === 1 && b.isDefault !== 1) return -1;
        if (a.isDefault !== 1 && b.isDefault === 1) return 1;
        return 0;
      });
    }

    ,
    firstDefaultId() {
      const first = this.filteredProfiles.find(p => p.isDefault === 1);
      return first ? first.id : null;
    },

    ...mapGetters('notifications', {
      notificationProfiles: 'profiles'
    })
  },

  created() {
    this.loadProfiles()
  },

  methods: {
    formatCNPJ(cnpj) {
      if (!cnpj) return '';
      const cleanCNPJ = cnpj.toString().replace(/\D/g, '');
      if (cleanCNPJ.length !== 14) return cnpj;
      return cleanCNPJ.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
      );
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    editProfile(profile) {
      this.selectedProfileId = profile.profileId;
      this.showEditModal = true;
    },

    async checkCnpjStatus(profile) {
      if (!profile.document || profile.document.length < 14) {
        this.$set(this.cnpjStatuses, profile.id, 'CNPJ inválido');
        return;
      }

      this.$set(this.loadingStatuses, profile.id, true);

      const cnpjFormatted = profile.document.replace(/[^\d]/g, "");

      const response = await this.$axios.post(`assets/checker/documentId`, {
        input: "documentId",
        value: cnpjFormatted,
      }, {
        validateStatus: function () { return true; }
      });

      var data = response.data;
      var companyData = (data && data.data && data.data.companyData) || (data && data.companyData);

      if (companyData) {
        var rawStatus = companyData.situacao || companyData.status || '';
        var statusValue = (rawStatus === 'ERROR' || !rawStatus) ? 'Indisponível' : rawStatus;
        this.$set(this.cnpjStatuses, profile.id, statusValue);
      } else {
        this.$set(this.cnpjStatuses, profile.id, 'Não encontrado');
      }

      this.$set(this.loadingStatuses, profile.id, false);
    },

    getCnpjStatusColor(profileId) {
      const status = this.cnpjStatuses[profileId];
      if (status === "ATIVA") {
        return "green";
      } else if (status === "BAIXADA" || status === "INAPTA") {
        return "red";
      } else {
        return "grey";
      }
    },

    async handleBulkCNPJCheck() {
      this.loadingBulkCNPJ = true;

      const profilesToCheck = this.profilesData.filter(profile =>
        !this.cnpjStatuses[profile.id] && profile.document && profile.document.length >= 14
      );

      for (let i = 0; i < profilesToCheck.length; i++) {
        const profile = profilesToCheck[i];

        if (i > 0) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }

        this.checkCnpjStatus(profile);
      }

      this.loadingBulkCNPJ = false;
    },

    async loadProfiles() {
      try {
        this.loading = true;
        const response = await this.$axios.get(`profiles?status=1`);
        if (response.data && response.data.data) {
          this.profiles = response.data.data;
        
          Object.keys(this.profiles).forEach(key => {
            const profile = this.profiles[key];
            if (profile.rfbStatus) {
              this.$set(this.cnpjStatuses, key, profile.rfbStatus);
            }
          });
        }
      } catch (error) {
        console.error('Erro ao carregar perfis:', error);
      } finally {
        this.loading = false;
      }
    },

    getProfilePendencies(profileId) {
      const pendencies = [];
      
      const profile = Object.values(this.notificationProfiles).find(p => p.profileId === profileId);
      if (!profile) return pendencies;

      const hasAddress = profile.statusAddress && 
                        Array.isArray(profile.statusAddress) && 
                        profile.statusAddress.length > 0;
      if (!hasAddress) {
        pendencies.push('Endereço');
      }

      const cadastral = profile.statusCadastral;
      const hasName = cadastral && cadastral.name && cadastral.name.trim() !== '';
      const hasTradingName = cadastral && cadastral.tradingName && cadastral.tradingName.trim() !== '';
      if (!hasName || !hasTradingName) {
        pendencies.push('Dados Cadastrais');
      }

      const bankAccounts = profile.statusBankAccount;
      let hasBankData = false;
      if (bankAccounts && Array.isArray(bankAccounts) && bankAccounts.length > 0) {
        hasBankData = bankAccounts.some(account => {
          const hasPix = account.pix && account.pix.trim() !== '';
          const hasBankAccount = account.agencyNumber && 
                                 account.agencyNumber.trim() !== '' && 
                                 account.accountNumber && 
                                 account.accountNumber.trim() !== '';
          return hasPix || hasBankAccount;
        });
      }
      if (!hasBankData) {
        pendencies.push('Dados Bancários');
      }

      return pendencies;
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: 'Roboto', sans-serif !important;
}

.v-data-table * {
  font-family: 'Roboto', sans-serif !important;
}

::v-deep .v-btn--loading .v-btn__loader {
  color: #203a75  !important;
}

::v-deep .v-btn.primary--text--loading .v-btn__loader {
  color: #0d47a1 !important;
}

::v-deep .v-btn.primary--loading .v-btn__loader {
  color: #0d47a1 !important;
}

::v-deep .v-progress-circular__overlay {
  stroke: #203a75  !important;
}

::v-deep .v-btn--loading .v-progress-circular__overlay {
  stroke: #203a75  !important;
}
</style>